import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
import { parseData } from '../../../lib/helpers';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';

const CollectionHeader = props => {
  const {
    collection: {
      title = '',
      subtitle = '',
      descriptionTitle = '',
      description = '',
      collectionImage,
      isDarkTheme
    },
    structuredPSData: { content = {} }
  } = props;

  const updateURL = e => {
    const targetLink = e.target.closest('a');
    if (
      targetLink &&
      window.location.pathname.includes('/mep/merchantapps/appcenter')
    ) {
      targetLink.href = targetLink.href.replace(
        /\/merchantapps\/appcenter/g,
        '/mep/merchantapps/appcenter'
      );
    }
    return null;
  };
  const [image] = parseData(collectionImage);
  const backgroundColor = image?.backgroundColor;
  const imageUrl = image?.url;
  const isImageBottomAligned = image?.isBottomAligned;
  const imageClass = cx({
    'collection-header-image': true,
    'bottom-aligned': isImageBottomAligned
  });
  const contentClass = cx({
    'collection-content': true,
    'bottom-aligned': isImageBottomAligned
  });

  return (
    <section className="width-wrapper">
      <div className="collection-header">
        <div
          className={contentClass}
          style={{ backgroundColor: backgroundColor }}
        >
          <div
            className={
              isDarkTheme === 'TRUE'
                ? `collection-header-text`
                : 'collection-header-text white'
            }
          >
            <h5 className="collection-header-super">
              {content.collectionsTitle}
            </h5>
            <HeadingText level={2}  className="collection-header-heading">{title}</HeadingText>
            <h4 className="collection-header-subheading">{subtitle}</h4>
          </div>
          <OptimizedImage
            imageUrl={imageUrl}
            className={imageClass}
            title={title}
            disableOptimization
          />
        </div>
        <div className="collection-header-text">
          <HeadingText level={2} >{descriptionTitle}</HeadingText>
          <BodyText
            aria-hidden="true"
            onClick={updateURL}
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
        </div>
      </div>
    </section>
  );
};

CollectionHeader.propTypes = {
  collection: PropTypes.object,
  structuredPSData: PropTypes.object
};

export default CollectionHeader;
